<template>
  <div>
    <h1 style="text-align: center">Ingreso de Insumos</h1>

    <CButtonToolbar>
      <CButtonGroup>
        <select v-model="selMes" class="custom-select">
          <option disabled value="">Seleccione un Mes</option>
          <option
            v-for="item in jsonMeses"
            :key="item.cod_mes"
            v-bind:value="item.cod_mes"
          >
            {{ item.txt_mes }}
          </option>
        </select>
        <div style="margin-right: 10px"></div>
        <select v-model="selAnio" class="custom-select">
          <option disabled value="">Seleccione un Año</option>
          <option
            v-for="item in jsonAnios"
            :key="item.aaaa"
            v-bind:value="item.aaaa"
          >
            {{ item.aaaa }}
          </option>
        </select>
        <div style="margin-right: 10px"></div>
        <CButton name="consulta" color="info" @click="ConsultaInsumos">
          Consulta
        </CButton>
      </CButtonGroup>
    </CButtonToolbar>
    <div style="margin-top: 10px">
      <CCol sm="12">
        <CTableWrapper
          :items="datosInsumos"
          hover
          striped
          border
          small
          fixed
          :registros="0"
          caption="Insumos"
        />
      </CCol>
    </div>
  </div>
</template>
<script>
import CTableWrapper from "./TablaIngresoInsumos.vue";
export default {
  components: {
    CTableWrapper,
  },
  data() {
    return {
      selMes: "",
      selAnio: "",
      jsonAnios: "",
      jsonMeses: "",
      datosInsumos: [
        /*   {
                
                'txt_nombre_insumo': 'Información Contable',
                'fecha_proceso': 'dato',
                'cant_registros_migrados': 'datos',
                'id_tipo_insumo_est': '1'
            } */
      ],
      data: {
        aaaamm: "",
        id_tipo_proceso_est: "1",
        id_grupo_est: "0",
      },
    };
  },
  mounted() {
    const payload = {
      metodo: "AnioMes",
      data: "",
    };
    this.$store.dispatch("metodoPost", payload).then((resp) => {
      if (resp) {
        var info = this.$store.getters.getRespuestaREST;
        this.jsonAnios = info.anios;
        this.jsonMeses = info.meses;
      }
    });
  },
  methods: {
    ConsultaInsumos() {
      {
        /*Recuaerda validar la ejecuacion si es que se selecciono nada */
        this.data.aaaamm = `${this.selAnio}${
          this.selMes < 10 ? `0${this.selMes}` : this.selMes
        }`;
        var config = {
          metodo: "EstadisticasProcesos",
          data: this.data,
        };

        this.$store.dispatch("metodoPost", config).then(() => {
          var tmp = this.$store.getters.getRespuestaREST;
          this.datosInsumos = tmp.Table;
          console.log(this.datosInsumos);
          if (this.datosInsumos.length != 0) {
            /* aqui puedes agregar algun comportamiento */
          } else {
            var Modal = {
              muestra: true,
              color: "info",
              contenido:
                "La búsqueda no genero resultados, verifique sus parametros",
              boton: "Aceptar",
              titulo: "Reportes Autorservicio",
            };

            this.$store.commit("showModal", Modal);
          }
        });
      }
    },
  },
  setup() {},
};
</script>